import swiperPropertyItem from "./swipers/swiperPropertyItem";
import swiperPropertyQuickView from "./swipers/swiperPropertyQuickView";
import swiperPropertyListing from "./swipers/swiperPropertyListing";
import swiperPropertySingle from "./swipers/swiperPropertySingle";
import swiperTestimonials from "./swipers/swiperTestimonials";
import swiperAreas from "./swipers/swiperAreas";

export default function initSwipers() {
    swiperPropertyItem();
    swiperPropertyQuickView();
    swiperPropertyListing();
    swiperPropertySingle();
    swiperTestimonials();
    swiperAreas();
}
